import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import tool from "./utils/tool";
import Axios from "axios";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import $ from "jquery";
import "./assets/reset.css";
import "@/assets/common.less";
import { addkey, delkey } from "@/utils/tool";
import Validator from "vue-validator";
Vue.use(Validator);
// 引入mockjs
require("./mock/index.js");
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$tool = tool;
Vue.prototype.$axios = Axios;

Vue.prototype.$addkey = addkey;
Vue.prototype.$delkey = delkey;
// Axios.defaults.baseURL = '/api'
new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js